module.exports = __webpack_public_path__ + "assets/images/entertainment_phase5.b3c374d3ca7f6bb7be6f7a3a1d7b1dbd.svg";